import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumber',
})
export class FormatNumberPipe implements PipeTransform {
  transform(value: number | string, args: [min: number, max: number]): string {
    const [min, max] = args;
    const multiplier = Math.pow(10, max);
    const truncatedValue = Math.floor(+value * multiplier) / multiplier;
    const priceFormat = new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: min,
      maximumFractionDigits: max,
    });
    return priceFormat.format(Number(truncatedValue));
  }
}
